// FilterableView component to show filterable content (used in "View All" mode)
import { Box, Chip, TextField, Typography } from '@mui/material';
import React, { useState } from 'react';
import { BackToLearningCenterLink } from './BackToLearningCenterLink';
import { ContentGrid } from './ContentGrid';

export function FilterableView({ title, viewAllPath, data }) {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedTags, setSelectedTags] = useState([]);

  const filteredData = data.filter(
    (item) =>
      item.title.toLowerCase().includes(searchTerm.toLowerCase()) &&
      (selectedTags.length === 0 || selectedTags.every((tag) => item.tags.includes(tag))),
  );

  const handleTagClick = (tag) => {
    if (selectedTags.includes(tag)) {
      setSelectedTags(selectedTags.filter((t) => t !== tag));
    } else {
      setSelectedTags([...selectedTags, tag]);
    }
  };

  const allTags = Array.from(new Set(data.flatMap((item) => item.tags)));

  return (
    <Box sx={{ padding: '30px' }}>
      <BackToLearningCenterLink />

      <Typography variant="h4">{title}</Typography>

      <Box sx={{ display: 'flex', alignItems: 'center', marginTop: 2 }}>
        <TextField
          variant="outlined"
          placeholder="Search Here"
          size="small"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          sx={{ flexGrow: 1, marginRight: 2 }}
        />
      </Box>

      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, marginTop: 1 }}>
        {allTags.map((tag) => (
          <Chip
            key={tag}
            label={tag}
            onClick={() => handleTagClick(tag)}
            color={selectedTags.includes(tag) ? 'primary' : 'default'}
          />
        ))}
      </Box>

      <ContentGrid
        data={filteredData}
        viewAllPath={viewAllPath}
      />
    </Box>
  );
}
